import {isXlminp} from 'Utils/xltools'
import {isYlsl} from 'Utils/ylsltools'

export default {
  computed: {
    showBack() {
      return !isXlminp()
    },
    showFooter() {
      return !isXlminp()
    },
    isXlminiprogram() {
      return isXlminp()
    },
    isYlslh5(){
      return isYlsl()
    }
  },
}
